// extracted by mini-css-extract-plugin
export default {"link":"src-components-common-TextLink-text-link-module__linkFRp7H"};